import { useMutation } from '@apollo/client';
import React, { createContext, useEffect, useState } from 'react';
import GET_WAREHOUSE_RELEASE from 'api/queries/GET_WAREHOUSE_RELEASE';
import UPDATE_WAREHOUSE_RELEASE_MODEL_SPECIFICATION from 'api/mutations/UPDATE_WAREHOUSE_REELASE_MODEL_SPECIFICATION';
import REMOVE_WAREHOUSE_RELEASE_MODEL from 'api/mutations/REMOVE_WAREHOUSE_RELEASE_MODEL';
import GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS from 'api/queries/GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS';
export const WarehouseReleaseContext = createContext({
    warehouseRelease: undefined,
    handleWarehouseReleaseModelSpecificationChange: () => { },
    handleWarehouseReleaseModelSpecificationRemove: () => { },
});
export const WarehouseReleaseProvider = ({ children, warehouseReleaseData, }) => {
    const [warehouseRelease, setWarehouseRelease] = useState();
    const [updateModelSpecification] = useMutation(UPDATE_WAREHOUSE_RELEASE_MODEL_SPECIFICATION, {
        refetchQueries: [
            {
                query: GET_WAREHOUSE_RELEASE,
                variables: {
                    id: warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.id,
                },
            },
        ],
    });
    const [removeModelSpecification] = useMutation(REMOVE_WAREHOUSE_RELEASE_MODEL, {
        refetchQueries: [
            {
                query: GET_WAREHOUSE_RELEASE,
                variables: {
                    id: warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.id,
                },
            },
            {
                query: GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS,
                variables: {
                    id: warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.id,
                },
            },
        ],
    });
    const handleWarehouseReleaseModelSpecificationRemove = (warehouseReleaseModelId) => {
        removeModelSpecification({
            variables: {
                warehouseReleaseModelId,
            },
        });
    };
    const handleWarehouseReleaseModelSpecificationChange = (modelSpecificationId) => {
        updateModelSpecification({
            variables: {
                warehouseReleaseId: warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.id,
                modelSpecificationId,
            },
            refetchQueries: [
                {
                    query: GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS,
                    variables: {
                        id: warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.id,
                    },
                },
            ],
        });
    };
    useEffect(() => {
        setWarehouseRelease(warehouseReleaseData);
    }, [warehouseRelease, warehouseReleaseData]);
    return (React.createElement(WarehouseReleaseContext.Provider, { value: {
            warehouseRelease,
            handleWarehouseReleaseModelSpecificationChange,
            handleWarehouseReleaseModelSpecificationRemove,
        } }, children));
};
